<template>
  <div class="main" :key="routeKey">
    <div class="loadstatus" v-show="loading">加载中...</div>
    <div v-show="!activeStatus&&!iframeState">
      <!-- banner swiper -->
      <swiper :options="swiperOption" ref="mySwiper" :style="{'height':bannerHeight+'px'}" v-show="bannerShow">
          <swiper-slide  v-for="(str,index) in listImg" :key="str.id">
            <div class="swiper-slide" :style="{ backgroundImage: 'url(' + str.cover_image + ')' }" @click="gotoArticle(str)">
              <div class="slide_title" >
                <p>{{str.title}}</p>
              </div>
            </div>
          </swiper-slide>
        <div class="swiper-pagination" slot="pagination" v-show="pagination_show"></div>
      </swiper>
      <!-- tab切换 分类+列表渲染 -->
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="showTab&&activeTemplate!=='titles'" class="tabNews">
        <el-tab-pane v-for="(item,index) in classifyInfo" :label="item.name" :name="item.string_id" :key="item.id" :value="item.id">
          <ul class="lists" v-if="activeTemplate=='list'">
            <li class="news-click cf" @click="gotoArticle(item)" v-for="(item,index) in listsArr">
              <img :src="item.cover_image" alt="">
              <div class="list_txt">
                <h3>{{item.title}}</h3>
                <p class="content">{{item.desc}}</p>
                <p class="sub_txt">
                  <span v-if="item.reply">评论:<span>{{item.reply_count}}</span>&nbsp;&nbsp;</span>
                  <span v-if="item.show_fav">点赞:<span>{{item.fav_count}}</span></span>
                </p>
              </div>
            </li>
          </ul>
          <div class="cards" v-if="activeTemplate=='block'">
            <div class="news-click card" @click="gotoArticle(item)" v-for="(item,index) in listsArr">
              <img :src="item.cover_image" alt="">
              <div class="tip_bg">
                <p class="tip_txt">{{item.title}}</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- tab 完全展示的模板情况 模板三 -->
      <div class="select_tabclass" ref="classiftysum" v-show="showTab&&activeTemplate=='titles'">
        <ul class="classField">
          <li v-for="(item,index) in classifyInfo" :class='{classBgColor:item.id==nowSindex}' @click="selectClassify(item)">{{item.name}}</li>
        </ul>
      </div>
      <!-- 折叠面板 模板三 -->
      <div class="el_coll three_list" v-if="showTab&&activeTemplate=='titles'" id="all_Lists" :style="{'height':lists_h+'px'}">
        <div :class="'everyList everyList'+item.id" v-for="(item,index) in listsArr">
          <div class="class_name">{{item.name}}</div>
          <div :class="'singlelist classify'+item.id" v-for="(singleArticle,index) in item.article">
            <div :class="'accordion accordion'+item.id" ref="pannelBut" @click="handleChange(singleArticle,index,item.id,singleArticle.id)" :id="singleArticle.id">
              <p>{{singleArticle.title}}</p>
              <i class="el-collapse-item__arrow el-icon-arrow-right" v-if="singleArticle.content_type===1"></i>
              <i class="icon ypt-icon ypt-icon-link" v-if="singleArticle.content_type===2||singleArticle.content_type===0"></i>
            </div>
            <div :class="'panel panel'+item.id" ref="pannelBox" :id="singleArticle.id">
            <p v-html="singleArticle.desc"></p>
            </div>
          </div>
        </div>
        <div class="end_tip">到底啦</div>
      </div>
      <!-- 模板三仅仅展示列表 -->
      <div class="el_coll three_list" v-if="!showTab&&activeTemplate=='titles'" id="all_Lists" :style="{'height':lists_h+'px'}">
          <div :class="'singlelist classify'+item.id" v-for="(item,index) in listsArr">
            <div :class="'accordion accordion'+item.id" ref="pannelBut" @click="handleChange(item,index,item.id,item.id)" :id="item.id">
              <p>{{item.title}}</p>
              <i class="el-collapse-item__arrow el-icon-arrow-right" v-if="item.content_type===1"></i>
              <i class="icon ypt-icon ypt-icon-link" v-if="item.content_type===2||item.content_type===0"></i>
            </div>
            <div :class="'panel panel'+item.id" ref="pannelBox" :id="item.id">
            <p v-html="item.desc"></p>
            </div>
          </div>
        <div class="end_tip">到底啦</div>
      </div>

      <!-- 仅展示列表情况 -->
      <div v-if="!showTab&&activeTemplate=='list'">
        <ul class="lists">
            <li class="news-click cf" @click="gotoArticle(item)" v-for="(item,index) in listsArr">
              <img :src="item.cover_image" alt="">
              <div class="list_txt">
                <h3>{{item.title}}</h3>
                <p class="content">{{item.desc}}</p>
                <p class="sub_txt">
                  <span v-if="item.reply">评论:<span>{{item.reply_count}}</span>&nbsp;&nbsp;</span>
                  <span v-if="item.show_fav">点赞:<span>{{item.fav_count}}</span></span>
                </p>
              </div>
            </li>
        </ul>
      </div>
      <!-- 模拟二 卡片列表 -->
      <div class="cards" v-if="!showTab&&activeTemplate=='block'">
        <div class="news-click card" @click="gotoArticle(item)" v-for="(item,index) in listsArr">
          <img :src="item.cover_image" alt="">
          <div class="tip_bg">
            <p class="tip_txt">{{item.title}}</p>
          </div>
        </div>
      </div>

      <div v-show="nodata">已经到底啦</div>
    </div>
    <!-- 活动上下架 -->
    <div class="active_status" v-show="activeStatus&&!iframeState">
      <img src="../assets/images/tip.png" alt="">
      <p class="status_tip">{{informationTip}}</p>
    </div>

    <!-- 嵌入外部的文章 -->
    <div id="scroll-wrapper">
      <iframe v-show="iframeState" id="show-iframe" :style="{'min-height':frameHeight+'px','width':frameWidth+'px'}" frameborder=0 name="showHere" :src="zjxw_url"></iframe>
    </div>
    <div class="return_zjxw_newslist" v-show="iframeState" @click="return_newslist()">
      <img :src="user_return_img" alt="">
    </div>
  </div>
</template>

<script>
// import Swiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.min.css';

import user_return from '@/assets/images/return.png'
export default {
  data () {
    return {
      routeKey: 0,
      pagination_show:false,
      loading:true,
      pannelHeight:'',
      user_return_img:user_return,
      lists_h:'',
      nowSindex:'',
      swiperOption: {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          observer:true,
          observeParents:true,
          pagination: {
            el: '.swiper-pagination'
          }
          // on:{
          //   slideChangeTransitionStart:function(){
          //     alert('初始化时触发了一次回调');
          //     console.log()
          //   }
          // }
      },
      swiper_op:'',
      showTab:true,
      url_jump:'',
      zjxw_url:'',
      frameHeight:300,
      bannerHeight:'',
      frameWidth:"100%",
      bannerShow:true,
      activeStatus:false,
      activeName:'first',
      classifyInfo:'',
      iframeState:false,
      activeTemplate:'',
      listsArr:'',
      shareApp:'',
      informationTip:'',
      InterfaceFist:'',//存第一个接口
      articleFace:'',//文章列表
      classify_id:'',
      listImg:'',
      now_client:'',
      pageNo:1,
      pageSize:20,
      listsTotal:'',
      getPageNo:'',
      nodata:false,
      /* 积分相关 */
      news_id: '',
      is_points: '',
      points_scene: '',
      keyword: '',
    }
  },
  created(){
    let _this = this;

    var window_ht = window.innerHeight || 600,
        body_ht = document.body.clientHeight  || 600;
    _this.frameHeight = Math.max(window_ht, body_ht);


    var window_wt = window.innerWidth||600,
        body_wt = document.body.clientWidth||600;
    _this.frameWidth = Math.max(window_wt, body_wt);

    _this.bannerHeight = (_this.frameWidth*360)/640;

    // let num = 20;
    // start = parseInt(_this.pageNo)*num
    $(window).scroll(function(){
      let scrollTop_html = $(this).scrollTop();
      let scrollHeight_html = $(document).height();
      let windowHeight = $(this).height();
      if (scrollTop_html+windowHeight===scrollHeight_html) {
        if (_this.pageNo<_this.getPageNo) {
            _this.pageNo = parseInt(_this.pageNo) +1;
            _this.articleList();
        }else{
          _this.nodata = true;
        }
      }
    });
  },
  watch:{
    iframeState(curVal,oldVal){
      // if (!curVal) {
      //   this.$refs.mySwiper.swiper.update();//切换到第一个slide，速度为1秒

      // }
      // console.log('swiper_opswiper_op')
      // console.log(curVal,oldVal);
      // if (curVal) {
      //   console.log('curVal有值')
      //   console.log(curVal)
      // }
    },
    '$route.query': function(val) {
      this.init();
    },
    deep: true
  },
  mounted() {
    this.init()
  },
  methods:{
    init() {
      let _this = this;
      let timer = null;
      let count = 0;
      // _this.swiper_op = _this.$refs.mySwiper.swiper;

      function doCPaction() {
        if (typeof(CP) == 'object' && CP._options.is_ready) {
          clearTimeout(timer);
          _this.iniData();
          _this.loading = false;
          CP.is_login(function (data) {
            CP.tools.writelog('get_is_login-222', data);
          });
          CP.get_client_info(function (data) {
            _this.now_client = data;
          });
        } else {
          count++;
          if (count > 10) {
            return ;
          }
          timer = setTimeout(doCPaction, 200);
        }
      }
      timer = setTimeout(doCPaction, 200);

      let ifram = document.getElementById('show-iframe');
      if (navigator.userAgent.match(/iPad|iPhone/i)) {
        let iframe_box = document.getElementById('scroll-wrapper');
        ifram.setAttribute('scrolling', 'no');
        iframe_box.appendChild(ifram)
      }
    },
    iniData(){
      let _this = this;
      let initInterObj = {
        m:'front',
        subm:'news',
        action:'detail',
      }
      _this.InterfaceFist = JSON.parse(JSON.stringify(_this.$route.query));
      let newInitInterObj = Object.assign({},initInterObj,_this.InterfaceFist);
      _this.Get({
        url:'/activity/api.php',
        data:newInitInterObj,
        success: function(data) {
          let newArr = data.data;
          if (newArr.banner_article) {
            _this.bannerShow = true;
            _this.listImg = newArr.banner_article;
          }else{
            _this.bannerShow = false;
          }

          if (_this.listImg.length>1) {
            _this.pagination_show = true
          }else{
            _this.pagination_show = false
          }

          _this.activeTemplate = newArr.template;
          window.document.title = newArr.page_title || '新闻活动专题';
          // window.yun_share._change(newArr.share_title, newArr.share_desc, newArr.share_link, newArr.share_image);
          if (newArr.classify_type==='1') {
            _this.showTab = true;
            _this.classifyInfo=newArr.classify;

            for(var i=0;i<_this.classifyInfo.length;i++){
              _this.classifyInfo[i].string_id =  _this.classifyInfo[i].id.toString();
            }

            _this.activeName = newArr.classify[0].string_id;
            _this.classify_id = newArr.classify[0].id;
            // _this.classify_id = newArr.classify[0].string_id;
          }else{
            _this.showTab = false;
          }

          if (newArr.template==='titles') {
            _this.articleAllList();
          }else{
            _this.articleList();
          }

          // _this.share(newArr.share_title, newArr.share_desc, newArr.share_link, newArr.share_image);

          _this.activeStatus = false;
          if (CP && CP._options.is_ready){
            CP.get_client_info(function (data) {
              CP.tools.writelog('get_client_info', data);
              if (data.client_code=='zjxw'||data.client_code=='h24'||data.client_code.indexOf('xsb')!==-1) {
                _this.shareApp = true;
              }else{
                _this.shareApp = false;
              }
            });
            CP.set_share(function () {}, true, {
                  title: newArr.share_title,
                  shareTo: '',
                  link: newArr.share_link,
                  imgUrl:newArr.share_image ,
                  shareSummary: newArr.share_desc,
                  id: '112',
                  type: 7,
                  datatype: 'link',
                  dataUrl: '',
                  'shareUrlScheme': ''
            });
          }

          /* 积分相关 */
          _this.news_id = newArr.id;
          _this.is_points = newArr.is_points;
          _this.points_scene = newArr.points_scene;
          _this.keyword = newArr.keyword;
          _this.pointsChange({
            keyword: newArr.keyword,
            news_id: newArr.id
          }, () => {}, newArr.is_points == 1 && newArr.points_scene == 2)
        },
        error:function(data){
          _this.activeStatus = true;
          _this.informationTip = data.msg
        }
      });
    },
    articleList(){//文章列表
      let _this = this;
      let articleObj = {
        m:'front',
        subm:'news',
        action:'article',
        classify_id:_this.classify_id,
        page:parseInt(_this.pageNo),
        size:parseInt(_this.pageSize)
      }
      _this.articleFace = Object.assign({},articleObj,_this.InterfaceFist);
      _this.Get({
        url:'/activity/api.php',
        data:_this.articleFace,
        success: function(data) {
          let listArr = data.data;
          _this.listsTotal = listArr.total;

          _this.getPageNo = Math.ceil(parseInt(_this.listsTotal) /parseInt(_this.pageSize));

          let listsData=listArr.list;
          if (_this.pageNo===1) {
            _this.listsArr = listsData;
          }else{
            for(var i=0; i<listsData.length;i++){
              _this.listsArr.push(listsData[i]);
            }
          }
        }
      });
    },
    articleAllList(){//所有分类文章列表
      let _this = this;
      let articleAllObj = {
        m:'front',
        subm:'news',
        action:'templatethree'
      }
      _this.articleAllFace = Object.assign({},articleAllObj,_this.InterfaceFist);
      _this.Get({
        url:'/activity/api.php',
        data:_this.articleAllFace,
        success: function(data) {
          let newDataThree = data.data;
          if (newDataThree.classify_type==='1') {
            _this.showTab = true;
            _this.listsArr = newDataThree.classify;
          }else{
             _this.showTab = false;
            _this.listsArr = newDataThree.article;
          }
          let listDom= document.getElementById("all_Lists");
          var screen_ht = window.innerHeight || 600;
          _this.lists_h = screen_ht - listDom.offsetTop;
        }
      });

      // document.body.addEventListener('touchmove',function(e){
      //   event.preventDefault();
      // },false);
      $('body').css({'position':'fixed',"width":"100%"});


    },
    gotoArticle(info){
      this.pointsChange({
        keyword: this.keyword,
        news_id: this.news_id,
        article_id: info.id
      }, () => {
        let _this = this;
        if (parseInt(info.type)!==0) {
          _this.$router.push({
            path:'Article',
            query:{articleId:info.id,instance_id:info.instance_id,mp_id:info.mp_id,preview:_this.InterfaceFist.preview}
          });
        }else{
          let hrefLink = info.ori_url.indexOf('https://mp.weixin.qq.com');
          let now = _this.now_client.client_code;
          if (hrefLink===-1) {
            if (now=='zjxw'||now=='h24'||now.indexOf("xsb")!==-1) {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              _this.zjxw_url = info.ori_url;
              _this.iframeState = true;
              $('body').css({"position":"static","height":"auto"});
            }else{
              let hrefUrl = info.ori_url
              window.location.href=hrefUrl;
              // window.open(hrefUrl);
            }
          }else{
            window.location.href=info.ori_url;
            // window.open(info.ori_url);
          }
        }
      }, this.is_points == 1 && this.points_scene == 1)
    },
    return_newslist(){//返回新闻列表
      let _this= this;
      _this.zjxw_url='';
      _this.iframeState = false;
      // $('body').css({'position':'fixed',"width":"100%"});
      $('body').css({"position":"initial","height":"auto"});

    },
    handleClick(tab, event) {
      let _this = this;
      _this.listsArr = []
      //获得分类列表
      _this.classify_id = tab.$attrs.value;
      _this.pageNo=1;
      _this.nodata = false;
      _this.articleList();
    },
    selectClassify(value_item){
      let _this = this;
      _this.nowSindex = value_item.id;
      // let el = event.target;
      // el.classList.toggle("classBgColor");


      // let listsBtnDom = document.getElementsByClassName('classsingle');

      // for(var i=0;i<listsBtnDom.length;i++){
      //   listsBtnDom[i].classList.value ='';
      // }
      _this.classify_id = value_item.id;
      let listDom= document.getElementById("all_Lists");
      let htmlDom = document.getElementsByTagName('html');
      let selectDomClass = document.querySelectorAll('.everyList');

      for(var i=0;i<selectDomClass.length;i++){
          if (selectDomClass[i].className.indexOf(value_item.id) != -1) {
              $(listDom)[0].scrollTop = selectDomClass[i].offsetTop;
          }
      }

    },
    handleChange(val,i,classifyid,singid){
      this.pointsChange({
        keyword: this.keyword,
        news_id: this.news_id,
        article_id: classifyid
      }, () => {
        let _this = this;
        let panelBtn = _this.$refs.pannelBut;
        for(var j=0;j<panelBtn.length;j++){
          let stringClass = 'accordion accordion'+classifyid;
          let pannelBtnSelect = panelBtn[j].className;
          let equal = false;
          if (pannelBtnSelect.indexOf(classifyid) != -1) {
              equal = true;
          }
          if (equal&&$(panelBtn[j])[0].id==singid) {
            panelBtn[j].classList.toggle("active");
          }
        }

        let panel = _this.$refs.pannelBox;
        let pannelDom;
        for(var k=0;k<panel.length;k++){
          var panelClass = 'panel panel'+classifyid;
          if (panel[k].className==panelClass&&$(panel[k])[0].id==singid) {
            pannelDom = panel[k];
          }
        }
        if (val.type===1) {//跳到自己的文章页面
          _this.$router.push({
            path:'Article',
            query:{articleId:val.id,instance_id:val.instance_id,mp_id:val.mp_id,preview:_this.InterfaceFist.preview}
          });
          return;
        }
        if(val.content_type===2){//跳链接
          let hrefLink = val.ori_url.indexOf('https://mp.weixin.qq.com');
          let now = _this.now_client.client_code;
          if (hrefLink===-1) {
            if (now=='zjxw'||now=='h24'||now.indexOf("xsb")!==-1) {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              _this.zjxw_url = val.ori_url;
              _this.iframeState = true;
              $('body').css({"position":"initial","height":"auto"});
            }else{
              let hrefUrl = val.ori_url
              window.location.href=hrefUrl;
            }
          }else{
            window.location.href=val.ori_url;
          }
        }else{
          if (pannelDom.style.maxHeight) {
              pannelDom.style.maxHeight = '';
          } else {
              pannelDom.style.maxHeight = pannelDom.scrollHeight + "px";
          }
        }
      }, this.is_points == 1 && this.points_scene == 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .lists img{
    width: 20%;
    float: left;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
  }
  .lists li{
    border-bottom: 1px solid#ccc;
    padding: 1rem 0;
    position: relative;
  }
  .content{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin: 0.8rem 0;
  }
  .list_txt{
    text-align: left;
    float: right;
    display: inline-block;
    width: 76%;
  }
  .lists{
    padding: 1rem;
  }
  .sub_txt{
    color: #a0a0a0;
  }
  .card{
    width: 45%;
    display: inline-block;
    margin: 2%;
    position: relative;
  }
  .cards{
    text-align: left;
  }
  .tip_bg{
    width: 100%;
    height: 3.5rem;
    position: absolute;
    bottom: 0px;
    color: #fff;
    background-color: rgba(0,0,0,0.7);
  }
  .tip_txt{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 0.4rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .active_status{
    /*position: relative;*/
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: #fff;
    text-align: center;
  }
  .active_status img{
    width: 15rem;
    margin: 0 auto;
    margin-top: 25%;
  }
  .status_tip{
    font-size: 1.5rem;
    margin-top: 2rem;
  }
  .tabNews .el-tabs__nav-wrap.is-top{
    padding: 0 1rem;
  }
  .tabNews .el-tabs__nav-next{
    font-size: 2rem;
  }
  .tabNews .el-tabs__nav-prev{
    font-size: 2rem;
  }
  .tabNews .el-tabs__nav-scroll{
    margin: 0 1rem;
  }
  #show-iframe html{
    overflow-x: hidden;
  }
  #show-iframe body{
    overflow-x: hidden;
  }
  .classField{
    text-align: left;
    /*display:-webkit-flex;
    display:flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;*/
  }
  .classField li{
    display: inline-block;
    width: 30%;
    border: 1px solid#ececec;
    border-radius: 15px;
    margin: 1%;
    padding: 1% 0;
    text-align: center;
  }
  .classBgColor{
    background-color: #ececec;
  }
  .select_tabclass{
    /*height: auto;*/
    padding: 3%;
    box-shadow: 0px 1px 6px #888888;
  }
  .el_coll .el-collapse{
    text-align: left;
  }
  .el_coll .el-icon-arrow-right{
    /*display: none;*/
  }
  .el_coll .ypt-icon-link{
    font-weight: 300;
  }
  .el_coll .el-collapse-item__arrow{
    line-height: normal;
    margin: 0px;
  }
  .el_coll .active .el-collapse-item__arrow{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .three_list{
    position: relative;
    overflow-y: auto;
  }
  .everyList{
    /*border-bottom: 1px solid#eee;*/
    /*margin: 0 3%;*/
    /*padding: 3% 0;*/
    font-size: 14px;
  }
  .class_name{
    text-align: left;
    background-color: #ececec;
    padding: 3%;
  }
  .singlelist{
    padding: 3%;
    border-bottom: 1px solid#eee;
  }
.accordion {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  /*background-color:#eee;*/
  color:#444;
  cursor:pointer;
  /*padding:18px;*/
  width:100%;
  border:none;
  text-align:left;
  outline:none;
  /*font-size:15px;*/
  transition:0.4s;
  -webkit-transition:0.4s;
  font-weight: bold;
  /*padding: 3% 0;*/
  /*padding-bottom: -3%*/
}
.accordion.active,.accordion:hover {
  /*background-color:#eee;*/
  /*padding-bottom: 3%;*/
}
.accordion p{
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /*display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;*/
}
.panel {
  /*padding:0 18px;*/
  text-align: left;
  background-color:white;
  max-height:0;
  overflow:hidden;
  transition:max-height 0.2s ease-out;
  -webkit-transition:max-height 0.2s ease-out;
  /*padding-top: 3%;*/
}
.panel p{
  margin-top: 3%;
}
.return_zjxw_newslist{
    width: 30%;
    margin: 0 auto;
    position: fixed;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
}
.end_tip{
  text-align: center;
  margin-bottom: 8%;
  margin-top: 3%;
}
.loadstatus{
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  z-index: 99;
}
#scroll-wrapper {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

/*.accordion:after {
  content:'\002B';
  color:#777;
  font-weight:bold;
  float:left;
  margin-left:5px;
}
.accordion.active:after {
  content:"\2212";
}*/
.tabNews .el-tabs__item:focus.is-active.is-focus:not(:active) {
         -webkit-box-shadow: none;
          box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue